/* User-started original films. No autoplay, looping, or automatic resume. */
(() => {
  'use strict';
  const init = () => {
    const films = [...document.querySelectorAll('[data-pb-user-film]')];
    if (!films.length || films[0].dataset.pbFilmReady) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const journals = [...new Set(films.map(v => v.closest('.dm-journal')).filter(Boolean))];
    const active = video => !video.paused && !video.ended;
    const sync = () => journals.forEach(journal => {
      const playing = films.some(v => journal.contains(v) && active(v));
      journal.dataset.pbFilmPlaying = String(playing);
      const track = journal.querySelector('.dm-filmtrack');
      if (track) {
        // Individual translate composes with the rail's existing animated
        // transform. Reset before measuring so repeated play never accumulates.
        track.style.setProperty('--pb-film-centering', '0px');
        if (playing) {
          const video = films.find(v => journal.contains(v) && active(v));
          const card = video.closest('.dm-filmprint');
          const strip = journal.querySelector('.dm-filmstrip');
          if (card && strip) {
            const frame = strip.getBoundingClientRect(), bounds = card.getBoundingClientRect();
            const left = Math.max(0, frame.left), right = Math.min(window.innerWidth, frame.right);
            if (right > left && bounds.width > 0) {
              const desiredLeft = left + (right - left - bounds.width) / 2;
              track.style.setProperty('--pb-film-centering', (desiredLeft - bounds.left).toFixed(2) + 'px');
            }
          }
        }
      }
      const button = journal.querySelector('[data-dm-rail-toggle]');
      if (button) {
        const paused = playing || journal.classList.contains('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        const label = button.querySelector('[data-dm-rail-label]');
        if (label) label.textContent = paused ? button.dataset.play : button.dataset.pause;
      }
    });
    const pauseAll = () => { films.forEach(v => v.pause()); sync(); };
    films.forEach(video => {
      video.dataset.pbFilmReady = 'true';
      video.addEventListener('play', () => {
        films.forEach(other => { if (other !== video && active(other)) other.pause(); });
        sync();
      });
      ['pause','ended','error'].forEach(type => video.addEventListener(type, sync));
      // A closed process disclosure must never leave its hidden film playing.
      const disclosure = video.closest('details');
      if (disclosure) disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) video.pause();
      });
    });
    // A request to resume the rail stops its film first. Existing manual rail
    // behavior continues unchanged when no film is playing.
    journals.forEach(journal => {
      journal.querySelector('[data-dm-rail-toggle]')?.addEventListener('click', event => {
        if (!films.some(v => journal.contains(v) && active(v))) return;
        event.preventDefault(); event.stopImmediatePropagation();
        films.filter(v => journal.contains(v)).forEach(v => v.pause());
        journal.classList.remove('is-paused'); sync();
      }, true);
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.pause();
      }), { threshold: 0 });
      films.forEach(video => observer.observe(video));
    }
    new MutationObserver(() => {
      if (document.documentElement.classList.contains('dm-paused')) pauseAll();
    }).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
    reduced.addEventListener('change', event => { if (event.matches) pauseAll(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); });
    window.addEventListener('pagehide', pauseAll);
    window.addEventListener('resize', sync, {passive:true});
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
